<template>
<div class="row col-at-sm col-at-md">
    <div class="section user-section full-width-at-md">
       <div class="card card--white user-info">
         <div class="card--container" style="position: relative">
          <v-menu bottom left class='top-right'>
            <button icon slot="activator">
              <h-icon>more_vert</h-icon>
            </button>
            <v-list>
              <v-list-tile  @click="switchProgram=true">
                <v-list-tile-title>Change Habit Program</v-list-tile-title>
              </v-list-tile>
              <v-list-tile  @click="dialog=true">
                <v-list-tile-title>Deactivate</v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu>
          <div class="top-left last-login">Last Login: {{lastLogin}}</div>

          <div class="user-image center">
            <v-avatar
              :tile="false"
              size="150"
              class="grey lighten-4 client-image"
              >
              <img :src="imgUrl" alt="avatar">
            </v-avatar>
            <router-link class="name" :to="{name: 'clientDetail', params: {id: client.id}}">
              {{fullName}}
            </router-link>
            <div class="habit-program" :to="{name: 'themesDetail', params: {id: client.habit_program.id}}">
              {{client.habit_program.name}}
            </div>
          </div>
        </div>
      </div>
    </div>
    <pie-charts :client="client" class="hide-at-xs flex"/>

        <!-- <commitments :clientId="client.id" />
      </div>
    </div>
  </div> -->
  <v-dialog
        v-model="dialog"
        transition="dialog-bottom-transition"
        max-width="500px"
      >
        <div class="card card--white">
        <div class="card card--container">
            <div class="section-headers">Deactivate {{ fullName }}</div>
            <div class="section">
              {{ fullName }} will no longer appear on your dashboard.
              Deactivating clients will also stop them from receiving exercises and daily reflections.
            </div>
            <div class="section">
              Type the word DEACTIVATE to confirm.
              <input type="text" v-model="deactivateConfirm" :rules="deactivateRule" />
            </div>
            <div>
              <h-btn primary @click="deactivate()">Save</h-btn>
              <h-btn flat @click="dialog=false">Cancel</h-btn>
            </div>
          </div>
        </div>
  </v-dialog>
  <switch-habit-program :display="switchProgram" @closed="switchProgram=false" :userId="client.id" />
</div>
</template>

<script>
import dataStore from "@/services/api/store";
import moment from "moment";
// import dailyExercise from "@/components/dailyExercise";
import assignNewExercise from "./assignNewExercise";
import switchHabitProgram from "./switchHabitProgram";
import commitments from "../createCommitment";
import titleCase from "@/services/titleCase";
import pieCharts from "./pieCharts";

const CLIENT_STORE = "CoachClients";

export default {
  props: ["client"],
  components: {
    // dailyExercise,
    assignNewExercise,
    switchHabitProgram,
    commitments,
    pieCharts
  },
  data() {
    return {
      dialog: false,
      newExercise: false,
      switchProgram: false,
      showAll: false,
      deactivateConfirm: "",
      info: {},
      deactivateRule: [
        () => this.deactivateConfirm === "DEACTIVATE" || "Must match DEACTIVATE"
      ]
    };
  },
  methods: {
    deactivate() {
      if (this.deactivateRule[0]() === true) {
        dataStore.destroy(CLIENT_STORE, this.client.id).then(() => {
          this.dialog = false;
          this.$emit("clientRemoved", this.client.id);
        });
      }
    }
  },
  computed: {
    fullName() {
      return `${titleCase(this.client.first_name)} ${titleCase(
        this.client.last_name
      )}`;
    },
    imgUrl() {
      return this.client.image || "/img/personHead.png";
    },
    lastLogin() {
      return moment(this.client.last_login).format('MMM DD, YYYY');
    }
  }
};
</script>

<style lang="less">
.top-right {
  position: absolute !important;
  right: 5px;
  top: 5px;
}
.top-left {
  position: absolute;
  left: 5px;
  top: 5px;
  margin:15px;
}

.user-image {
  display: flex;
  flex-direction: row;
  margin-bottom: 10px;
  .user-name {
    display: flex;
    flex-direction: column;
    .habit-program {
      letter-spacing: 0px;
      font-size: 12px;
      opacity: 0.7;
      text-transform: capitalize;
      line-height: 15px;
    }
  }
}
.center {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 23px;
  height: 100%;
}
.card-client {
  display: flex;
  flex-direction: row;
  flex: 100%;
}
.to-the-left {
  right: 0;
  top: 0;
  position: absolute;
}
.wrapper {
  display: flex;
  flex-direction: column;
  line-height: 25px;
  /* text-transform: uppercase; */
  letter-spacing: 2px;
}
.name {
  font-size: 18px;
  letter-spacing: 1px;
}
.user-info {
  width: 100%;
  height: 100%;
}
.user-section {
  width: 400px;
  margin-right: 8px;
}
.user-name {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.client-image {
  margin-right: 12px;
}
.client {
  display: flex;
  width: 100%;
  margin-bottom: 15px;
}

.last-login {
  font-size: 12px;
  opacity: .7;
}

.user-info {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: start;
}
.user-info--number {
  font-size: 25px;
}

.user-info--txt {
  font-size: 10px;
  text-transform: uppercase;
  opacity: 0.8;
}

.info-row {
  display: flex;
  flex-direction: row;
  margin-bottom: 10px;
}

.info-warning {
  color: red;
}
.info-success {
  color: blue;
}
.info-info {
  color: green;
}
.info-na {
  color: black;
  opacity: 0.6;
}
</style>
